import app from 'flarum/forum/app';
import {extend, override} from 'flarum/common/extend';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';

import NecrobumpingCheck from './components/NecrobumpingCheck';

app.initializers.add('annonny/prevent-arguement', () => {
  extend(ReplyComposer.prototype, 'headerItems', function (items) {
    if (this.attrs.discussion.tags().some(tag => tag.slug() === 'shudong')) {
      items.add(
        'prevent-arguement',
        NecrobumpingCheck.component()
      );
    }
  });
})
